import { atom as o } from "jotai";
import { atomWithDefault as a } from "jotai/utils";
const r = o({
  amount: 0,
  currency: "eur"
}), u = a((t) => t(r)), f = o(
  null,
  (t, m, e) => {
    m(u, (n) => ({ ...n, ...e }));
  }
);
export {
  u as paymentAtom,
  r as paymentAtomDefault,
  f as setPaymentAtom
};
